import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorValues from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { queryOrganList, getPerson, initPerTable, getGroupList, getGroupMembers, addGroup, updateGroup, deleteGroup, checkGroupPermission } from '@/services/organMgr';
export default {
  data: function data() {
    var _this = this;
    return {
      // 群组列表
      groupList: [],
      columns: [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 80,
        customRender: function customRender(text, record, index) {
          return index + 1;
        }
      }, {
        title: '群组名称',
        dataIndex: 'groupName',
        key: 'groupName'
      }, {
        title: '群组描述',
        dataIndex: 'groupDesc',
        key: 'groupDesc'
      }, {
        title: '成员数量',
        dataIndex: 'memberCount',
        key: 'memberCount',
        width: 100
      }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '创建人',
        dataIndex: 'createUserName',
        key: 'createUserName'
      }, {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 180
      }, {
        title: '操作',
        key: 'action',
        width: 150,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          _this.pagination.pageSize = pageSize;
          _this.pagination.current = 1;
          _this.loadGroupList();
        },
        onChange: function onChange(current) {
          _this.pagination.current = current;
          _this.loadGroupList();
        }
      },
      loading: false,
      searchGroupName: '',
      // 模态框
      modalVisible: false,
      modalTitle: '新建群组',
      isEdit: false,
      currentGroupId: null,
      // 群组表单
      groupForm: {
        groupName: '',
        groupDesc: '',
        status: 1,
        organId: '',
        organType: '',
        memberIds: []
      },
      groupFormRules: {
        groupName: [{
          required: true,
          message: '请输入群组名称',
          trigger: 'blur'
        }]
      },
      // 当前组织信息
      currentOrganId: '',
      currentOrganName: '',
      currentOrganType: 2,
      // 默认党委组织架构
      organList: [],
      // 人员选择
      searchOrganName: '',
      searchUserName: '',
      organTree: [],
      organUserTree: [],
      expandedKeys: [],
      selectedMemberIds: [],
      selectedMembers: [],
      allUsers: [],
      organUsers: [],
      loadingUsers: false,
      loadingTree: false
    };
  },
  mounted: function mounted() {
    // 初始化组织树
    this.initOrganTree();
    // 加载群组列表
    this.loadGroupList();
  },
  methods: {
    // 初始化组织树
    initOrganTree: function initOrganTree() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        queryOrganList({
          inputType: _this2.currentOrganType
        }).then(function (res) {
          if (res.data.code === 200) {
            var organData = res.data.data;
            if (organData && organData.length > 0) {
              _this2.organList = organData;
              // 转换为树结构
              _this2.organTree = _this2.convertOrganTree(organData);
            }
            resolve(organData);
          } else {
            resolve([]);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 处理组织选择变化
    handleOrganChange: function handleOrganChange(organId) {
      if (!organId) {
        this.organUserTree = [];
        return;
      }
      // 提取真正的组织 ID 和组织类型
      var parts = organId.split('-');
      var realOrganId = parts[0];
      var organType = parts[1] || this.currentOrganType;
      this.currentOrganId = realOrganId;
      this.currentOrganType = parseInt(organType);

      // 查找组织名称
      var _findOrganName = function findOrganName(data, key) {
        var _iterator = _createForOfIteratorHelper(data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.key === key) {
              return item.title;
            }
            if (item.children && item.children.length > 0) {
              var name = _findOrganName(item.children, key);
              if (name) return name;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return null;
      };
      this.currentOrganName = _findOrganName(this.organList, realOrganId) || '';

      // 构建组织和人员的混合树
      this.buildOrganUserTree(this.organList);
    },
    // 转换组织树
    convertOrganTree: function convertOrganTree(organData) {
      var _this3 = this;
      return organData.map(function (item) {
        var treeItem = {
          title: item.title,
          value: "".concat(item.key, "-").concat(_this3.currentOrganType),
          key: "".concat(item.key, "-").concat(_this3.currentOrganType),
          originalKey: item.key,
          children: []
        };
        if (item.children && item.children.length > 0) {
          treeItem.children = _this3.convertOrganTree(item.children);
        }
        return treeItem;
      });
    },
    // 构建组织和人员的混合树
    buildOrganUserTree: function buildOrganUserTree(organData) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _buildTree;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this4.loadingTree = true;
              _buildTree = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
                  var result, _iterator2, _step2, _loop, _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        result = [];
                        _iterator2 = _createForOfIteratorHelper(data);
                        _context2.p = 1;
                        _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                          var item, treeItem, res, seenUserIds, uniqueUsers, childTree, _t;
                          return _regenerator().w(function (_context) {
                            while (1) switch (_context.p = _context.n) {
                              case 0:
                                item = _step2.value;
                                treeItem = {
                                  title: item.title,
                                  key: "".concat(item.key, "-").concat(_this4.currentOrganType),
                                  originalKey: item.key,
                                  isUser: false,
                                  children: []
                                }; // 加载该组织下的人员
                                _context.p = 1;
                                _context.n = 2;
                                return initPerTable({
                                  type: _this4.currentOrganType,
                                  organId: item.key,
                                  pageCurrent: 1,
                                  pageSize: 1000
                                });
                              case 2:
                                res = _context.v;
                                if (res.data.code === 200) {
                                  // 去重
                                  seenUserIds = new Set();
                                  uniqueUsers = [];
                                  res.data.records.forEach(function (user) {
                                    if (!seenUserIds.has(user.userId)) {
                                      seenUserIds.add(user.userId);
                                      uniqueUsers.push(user);
                                    }
                                  });

                                  // 将人员添加为子节点
                                  uniqueUsers.forEach(function (user) {
                                    treeItem.children.push({
                                      title: "".concat(user.userName, " (").concat(user.postName, ")"),
                                      key: "user-".concat(user.userId),
                                      isUser: true,
                                      userData: user,
                                      children: []
                                    });
                                  });
                                }
                                _context.n = 4;
                                break;
                              case 3:
                                _context.p = 3;
                                _t = _context.v;
                              case 4:
                                if (!(item.children && item.children.length > 0)) {
                                  _context.n = 6;
                                  break;
                                }
                                _context.n = 5;
                                return _buildTree(item.children);
                              case 5:
                                childTree = _context.v;
                                treeItem.children = [].concat(_toConsumableArray(treeItem.children), _toConsumableArray(childTree));
                              case 6:
                                result.push(treeItem);
                              case 7:
                                return _context.a(2);
                            }
                          }, _loop, null, [[1, 3]]);
                        });
                        _iterator2.s();
                      case 2:
                        if ((_step2 = _iterator2.n()).done) {
                          _context2.n = 4;
                          break;
                        }
                        return _context2.d(_regeneratorValues(_loop()), 3);
                      case 3:
                        _context2.n = 2;
                        break;
                      case 4:
                        _context2.n = 6;
                        break;
                      case 5:
                        _context2.p = 5;
                        _t2 = _context2.v;
                        _iterator2.e(_t2);
                      case 6:
                        _context2.p = 6;
                        _iterator2.f();
                        return _context2.f(6);
                      case 7:
                        return _context2.a(2, result);
                    }
                  }, _callee, null, [[1, 5, 6, 7]]);
                }));
                return function buildTree(_x) {
                  return _ref.apply(this, arguments);
                };
              }();
              _context3.n = 1;
              return _buildTree(organData);
            case 1:
              _this4.organUserTree = _context3.v;
              _this4.loadingTree = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee2);
      }))();
    },
    // 加载组织人员
    loadOrganUsers: function loadOrganUsers() {
      var _this5 = this;
      this.loadingUsers = true;
      initPerTable({
        type: this.currentOrganType,
        organId: this.currentOrganId,
        pageCurrent: 1,
        pageSize: 1000 // 加载足够多的人员
      }).then(function (res) {
        _this5.loadingUsers = false;
        if (res.data.code === 200) {
          // 去重：使用 Map 来确保 userId 唯一
          var uniqueUsers = [];
          var seenUserIds = new Set();
          res.data.records.forEach(function (user) {
            if (!seenUserIds.has(user.userId)) {
              seenUserIds.add(user.userId);
              uniqueUsers.push(user);
            }
          });
          _this5.organUsers = uniqueUsers;
          _this5.allUsers = uniqueUsers;
        }
      }).catch(function (error) {
        _this5.loadingUsers = false;
      });
    },
    // 处理组织搜索
    handleOrganSearch: function handleOrganSearch() {
      // 这里可以添加组织搜索逻辑，过滤 organUserTree

      if (this.searchOrganName) {
        // 递归过滤树
        var _filterTree = function filterTree(data, keyword) {
          return data.filter(function (item) {
            if (item.title.includes(keyword)) {
              return true;
            }
            if (item.children && item.children.length > 0) {
              item.children = _filterTree(item.children, keyword);
              return item.children.length > 0;
            }
            return false;
          });
        };
        // 这里可以实现搜索过滤逻辑
      }
    },
    // 加载群组列表
    loadGroupList: function loadGroupList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this6.loading = true;
              _context4.p = 1;
              _context4.n = 2;
              return getGroupList(_this6.currentOrganId, _this6.currentOrganType, _this6.searchGroupName, _this6.pagination.current, _this6.pagination.pageSize);
            case 2:
              res = _context4.v;
              _this6.loading = false;
              if (res.data.code === 200) {
                _this6.groupList = res.data.records;
                _this6.pagination.total = res.data.total;
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              _this6.loading = false;
            case 4:
              return _context4.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }))();
    },
    // 搜索群组
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.loadGroupList();
    },
    // 打开新建群组模态框
    openAddGroupModal: function openAddGroupModal() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this7.isEdit = false;
              _this7.modalTitle = '新建群组';
              _this7.currentGroupId = null;
              _this7.groupForm = {
                groupName: '',
                groupDesc: '',
                status: 1,
                organId: undefined,
                organType: _this7.currentOrganType,
                memberIds: []
              };
              _this7.selectedMemberIds = [];
              _this7.selectedMembers = [];
              _this7.organUserTree = [];
              _this7.modalVisible = true;

              // 确保组织数据已加载，然后构建树
              if (!(_this7.organList.length === 0)) {
                _context5.n = 1;
                break;
              }
              _context5.n = 1;
              return _this7.initOrganTree();
            case 1:
              if (!(_this7.organList.length > 0)) {
                _context5.n = 2;
                break;
              }
              _context5.n = 2;
              return _this7.buildOrganUserTree(_this7.organList);
            case 2:
              return _context5.a(2);
          }
        }, _callee4);
      }))();
    },
    // 处理编辑按钮点击
    handleEdit: function handleEdit(record) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var permRes, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return checkGroupPermission(record.groupId);
            case 1:
              permRes = _context6.v;
              if (permRes.data.hasPermission) {
                _context6.n = 2;
                break;
              }
              _this8.$message.error('您没有权限编辑该群组');
              return _context6.a(2);
            case 2:
              _this8.editGroup(record);
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t4 = _context6.v;
              _this8.$message.error('检查权限失败');
            case 4:
              return _context6.a(2);
          }
        }, _callee5, null, [[0, 3]]);
      }))();
    },
    // 处理删除按钮点击
    handleDelete: function handleDelete(record) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var permRes, _t5;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return checkGroupPermission(record.groupId);
            case 1:
              permRes = _context7.v;
              if (permRes.data.hasPermission) {
                _context7.n = 2;
                break;
              }
              _this9.$message.error('您没有权限删除该群组');
              return _context7.a(2);
            case 2:
              _this9.confirmDeleteGroup(record);
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t5 = _context7.v;
              _this9.$message.error('检查权限失败');
            case 4:
              return _context7.a(2);
          }
        }, _callee6, null, [[0, 3]]);
      }))();
    },
    // 编辑群组
    editGroup: function editGroup(record) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this0.isEdit = true;
              _this0.modalTitle = '编辑群组';
              _this0.currentGroupId = record.groupId;
              _this0.groupForm = {
                groupName: record.groupName,
                groupDesc: record.groupDesc,
                status: record.status,
                organId: "".concat(record.organId, "-").concat(record.organType),
                organType: record.organType,
                memberIds: []
              };

              // 确保组织数据已加载
              if (!(_this0.organList.length === 0)) {
                _context8.n = 1;
                break;
              }
              _context8.n = 1;
              return _this0.initOrganTree();
            case 1:
              // 设置当前组织信息
              _this0.currentOrganId = record.organId;
              _this0.currentOrganType = record.organType;

              // 构建组织和人员的混合树
              _context8.n = 2;
              return _this0.buildOrganUserTree(_this0.organList);
            case 2:
              // 加载群组成员
              getGroupMembers(record.groupId, record.organId).then(function (res) {
                if (res.data.code === 200) {
                  var members = res.data.members;
                  _this0.selectedMemberIds = members.map(function (member) {
                    return member.userId;
                  });
                  _this0.selectedMembers = members;
                  _this0.groupForm.memberIds = _this0.selectedMemberIds;
                }
              });
              _this0.modalVisible = true;
            case 3:
              return _context8.a(2);
          }
        }, _callee7);
      }))();
    },
    // 确认删除群组
    confirmDeleteGroup: function confirmDeleteGroup(record) {
      var _this1 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u7FA4\u7EC4 \"".concat(record.groupName, "\" \u5417\uFF1F"), '确认删除', {
        type: 'warning',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        deleteGroup(record.groupId).then(function (res) {
          if (res.data.code === 200) {
            _this1.$message.success('删除成功');
            _this1.loadGroupList();
          } else {
            _this1.$message.error(res.data.message || '删除失败');
          }
        }).catch(function () {
          _this1.$message.error('删除失败');
        });
      }).catch(function () {});
    },
    // 处理模态框确定
    handleModalOk: function handleModalOk() {
      var _this10 = this;
      this.$refs.groupForm.validate(function (valid) {
        if (valid) {
          // 构建 memberList，包含 userId 和 postName
          var memberList = _this10.selectedMembers.map(function (member) {
            return {
              userId: member.userId,
              postName: member.postName || ''
            };
          });

          // 提取真正的组织ID（去掉后缀的组织类型）
          var organId = _this10.groupForm.organId;
          if (organId && typeof organId === 'string' && organId.includes('-')) {
            organId = parseInt(organId.split('-')[0]);
          }
          var submitData = _objectSpread(_objectSpread({}, _this10.groupForm), {}, {
            organId: organId,
            memberIds: _this10.selectedMemberIds,
            memberList: memberList
          }, _this10.isEdit ? {
            groupId: _this10.currentGroupId
          } : {});
          var request = _this10.isEdit ? updateGroup(submitData) : addGroup(submitData);
          request.then(function (res) {
            if (res.data.code === 200) {
              _this10.$message.success(_this10.isEdit ? '更新成功' : '创建成功');
              _this10.modalVisible = false;
              // 重置组织过滤条件，避免编辑时设置的 organId/organType 影响列表查询
              _this10.currentOrganId = '';
              _this10.currentOrganType = 2;
              _this10.loadGroupList();
            } else {
              _this10.$message.error(res.data.message || (_this10.isEdit ? '更新失败' : '创建失败'));
            }
          });
        }
      });
    },
    // 处理模态框取消
    handleModalCancel: function handleModalCancel() {
      this.modalVisible = false;
    },
    // 处理成员选择
    handleMemberCheck: function handleMemberCheck(e, userData) {
      var userId = userData.userId;
      if (e.target.checked) {
        // 检查是否已经存在
        if (!this.selectedMemberIds.includes(userId)) {
          this.selectedMemberIds.push(userId);
          this.selectedMembers.push(userData);
        }
      } else {
        this.selectedMemberIds = this.selectedMemberIds.filter(function (id) {
          return id !== userId;
        });
        this.selectedMembers = this.selectedMembers.filter(function (m) {
          return m.userId !== userId;
        });
      }
    },
    // 移除成员
    removeMember: function removeMember(userId) {
      this.selectedMemberIds = this.selectedMemberIds.filter(function (id) {
        return id !== userId;
      });
      this.selectedMembers = this.selectedMembers.filter(function (m) {
        return m.userId !== userId;
      });
    },
    // 清空已选成员
    clearSelectedMembers: function clearSelectedMembers() {
      this.selectedMemberIds = [];
      this.selectedMembers = [];
    },
    // 处理树节点展开
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
    }
  }
};